export * from '@primeuix/themes/lara/organizationchart';
export { default } from '@primeuix/themes/lara/organizationchart';
